import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a1f0004"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex overflow-auto align-right"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store";
import { useRoute } from "vue-router";
import AccountService from "../../accounts/services/AccountService";
import { Actions } from "@/store/enums/StoreEnums";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import EditAlias from "@/projects/client/modules/sales/components/modal/EditAlias.vue";
import { isMobile } from "@/core/config/WindowConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'SalesSelector',
  setup(__props) {

const store = useStore();
const route = useRoute();
const EditAliasRef = ref(null);
const salesAccount = ref(store.state.SalesModule.salesAccount);
const salesAccounts = ref([]);
const defaultSalesAccount = store.state.AuthModule.user?.defaultSalesAccount;

onMounted(async () => {
  const res = await AccountService.queryAccounts({
    role: AccountRoleTypes.Sales,
  });
  if (res.data.length === 0) return;
  salesAccounts.value = res.data;

  if (salesAccounts.value.length > 0 && !salesAccount.value) {
    if (defaultSalesAccount && defaultSalesAccount !== "0") {
      var defaultAccount = salesAccounts.value.find(
        (item) => item.uid == defaultSalesAccount
      );
      if (defaultAccount) {
        await store.dispatch(Actions.PUT_SALES_ACCOUNT, {
          uid: defaultAccount.uid,
          salesSelfGroupName: defaultAccount.code,
          siteId: defaultAccount.siteId,
        });
        salesAccount.value = {
          uid: defaultAccount.uid,
          salesSelfGroupName: defaultAccount.code,
        };
        return;
      }
    }

    await store.dispatch(Actions.PUT_SALES_ACCOUNT, {
      uid: res.data[0].uid,
      siteId: res.data[0].siteId,
      salesSelfGroupName: res.data[0].code,
    });
    salesAccount.value = {
      uid: res.data[0].uid,
      salesSelfGroupName: res.data[0].code,
    };
  }
});

const fetchData = async () => {
  const res = await AccountService.queryAccounts({
    role: AccountRoleTypes.Sales,
  });
  salesAccounts.value = res.data;
};

const showSalesSelector = computed(() => /^\/sales/.test(route.path));

const changeSalesAccount = (
  uid: number,
  salesSelfGroupName: string,
  siteId: number
) => {
  if (uid == salesAccount.value?.uid) return;
  store.dispatch(Actions.PUT_SALES_ACCOUNT, {
    uid: uid,
    salesSelfGroupName: salesSelfGroupName,
    siteId: siteId,
  });
  salesAccount.value = { uid };
  window.location.reload();
};

const editAlias = () => {
  EditAliasRef.value.show(salesAccounts.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showSalesSelector.value && salesAccounts.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesAccounts.value, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["btn btn-small me-2 cursor-pointer", {
        'btn-light': salesAccount.value.uid === item.uid,
        'btn-primary': salesAccount.value.uid !== item.uid,
        'mobile-btn': _unref(isMobile) === true,
      }]),
              key: item.uid,
              onClick: ($event: any) => (
        changeSalesAccount(item.uid, item.salesSelfGroupName, item.siteId)
      )
            }, _toDisplayString(item.uid) + "(" + _toDisplayString(_ctx.$t("type.siteType." + item.siteId)) + ") " + _toDisplayString(item.alias), 11, _hoisted_2))
          }), 128)),
          _createElementVNode("button", {
            class: "btn btn-small cursor-pointer",
            onClick: editAlias
          }, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(EditAlias, {
      ref_key: "EditAliasRef",
      ref: EditAliasRef,
      onUpdate: fetchData
    }, null, 512)
  ], 64))
}
}

})